module.exports = __webpack_public_path__ + "media/images/es_419/concept_leadership-703dd2f34c2c1610ecb881a8131d9bf7.png";